import Header from "../componentes/header/header";
import Footer from "../componentes/footer/footer";
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './conserto_relogio.css';
import { assets } from "../assets/assets";
import { abrirOrcamentoWhats, trazerRodapePaginasServicos, trazerTituloServicos } from "../utils/utils";

const ConsertoRelogio = () => {

  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Trinco | Serviços de relógios";
  }, []);

  return (
    <div className="servico-detalhe-page">
      <Header />

      {/* Hero Banner */}
      <section className="servico-hero" style={{ backgroundImage: `url(${assets.consertoRelogios})` }}>
        <div className="servico-hero-overlay">
          <h1>Serviços de Relógios</h1>
          <p>Para quem usa relógio todos os dias.</p>
        </div>
      </section>

      {/* Conteúdo Explicativo */}
      <main className="conteudo-servico-container">

        <article className="bloco-texto">
          <h2>{trazerTituloServicos('relógios')}</h2>
        </article>

        {/* Bloco 1: Ajustes e Pinos */}
        <section className="sessao-explicativa">
          <div className="texto-lado">
            <h3>Funcionamento</h3>
            <h4>Revisão geral</h4>
            <p>Desmontagem, limpeza e lubrificação.</p>
            <h4>Troca de máquina</h4>
            <p>Substituição da máquina para restabelecer o funcionamento.</p>

          </div>
          <div className="imagem-lado">
            <img src={assets.funcionamentoRelogio} alt="Ajuste de pulseira" />
          </div>
        </section>

        {/* Bloco 2: Revisão e Máquina */}
        <section className="sessao-explicativa reverse">
          <div className="texto-lado">
            <h3>Pulseira</h3>
            <h4>Redução de pulseira</h4>
            <p>Diminuição de elos para ajuste ao pulso.</p>
            <h4>Confecção de pinos</h4>
            <p>Pinos sob medida para fixação da pulseira.</p>
          </div>
          <div className="imagem-lado">
            <img src={assets.pulseiraRelogio} alt="Mecanismo de relógio" />
          </div>
        </section>

        {/* Bloco 3: Vedação */}
        <section className="sessao-explicativa">
          <div className="texto-lado">
            <h3>Proteção Contra Água</h3>
            <h4>Vedação do relógio</h4>
            <p>Substituição das borrachas de proteção, com teste de pressão para verificação de resistência à água.</p>
          </div>
          <div className="imagem-lado">
            <img src={assets.vedacaoRelogio} alt="Teste de vedação" />
          </div>
        </section>

        <div className="fechamento-texto">
          <h4>{trazerRodapePaginasServicos('serviços de relógios')}</h4>
        </div>

        {/* CTA FINAL */}
        <div className="cta-container-detalhe">
          <button className="btn-orcamento-whats" onClick={() => abrirOrcamentoWhats('serviços de relógios')}>
            Solicitar orçamento
          </button>
          <button className="btn-voltar-simples" onClick={() => navigate('/')}>
            Voltar para o início
          </button>
        </div>
      </main>

      <Footer />
    </div>
  );

}

export default ConsertoRelogio;